"use client";

import React from "react";
import { Send, Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LetsWorkTogether() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <>
      {/* CONTACT SECTION */}
      <section data-section-id="38794" id="drop-us-a-line" ref={ref} className="bg-black py-24 sm:py-32 relative overflow-hidden dark">
        <div className="container mx-auto px-4 md:px-6 max-w-3xl">
          <div className={cn("text-center mb-12 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4 tracking-tight">
              Contact Us
            </h2>
            <p className="text-white text-lg max-w-xl mx-auto font-sans">
              Drop us a line!
            </p>
          </div>

          <div className={cn("bg-[#1A1A1A] backdrop-blur-sm rounded-sm p-6 md:p-10 border border-white/20 transition-all duration-700 delay-200 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <FormProvider formKey="contact_form_home" formId="contact_form_home" sectionName="drop-us-a-line" defaultValues={{
            name: "",
            email: "",
            phone: "",
            service_interest: "",
            message: ""
          }} validationRules={{
            name: {
              required: "Name is required"
            },
            email: {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email address"
              }
            },
            service_interest: {
              required: "Please select an interest"
            },
            message: {
              required: "Message is required"
            }
          }}>
              <ContactForm />
            </FormProvider>
          </div>
        </div>
      </section>

      {/* 🔥 STAGE PLOT SECTION (AGORA FUNCIONA) */}
      <StagePlotSection />
    </>;
}
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-12">
        <h3 className="text-3xl text-white">Message Sent!</h3>
        <p className="text-gray-300">{successMessage}</p>
        <Button onClick={resetForm} className="mt-6">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" render={({
      field
    }) => <Input placeholder="Name" {...field} />} />

      <FormField control={control} name="email" render={({
      field
    }) => <Input type="email" placeholder="Email" {...field} />} />

      <FormField control={control} name="message" render={({
      field
    }) => <Textarea placeholder="Message" {...field} />} />

      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Sending..." : "Send"}
      </Button>
    </Form>;
}
function StagePlotSection() {
  return <section className="bg-black border-t border-white/10 py-16 px-4">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl text-white mb-6">Stage Plot</h2>

        <p className="text-gray-400 mb-10">
          Full band live setup layout for venues and event planning.
        </p>

        <img src="https://loving-airedale.10web.cloud/wp-content/uploads/2026/03/STAGEPLOT.png" alt="Stage Plot" className="mx-auto rounded shadow-lg" />
      </div>
    </section>;
}